enum ContagemCargaHorariaEnum {
    LetivaBase = 1,
    LetivaEventual,
    LetivaSubstituicao,
    Adicional,
    NaoLetivaBase,
    NaoLetivaEventual,
    NaoLetivaSubstituicao,
    HoraExtra,
}

const ContagemCargaHorariaEnumLabel = new Map<ContagemCargaHorariaEnum, string>(
    [
        [ContagemCargaHorariaEnum.LetivaBase, "Letiva Base"],
        [ContagemCargaHorariaEnum.LetivaEventual, "Letiva Eventual"],
        [ContagemCargaHorariaEnum.LetivaSubstituicao, "Letiva Substituição"],
        [ContagemCargaHorariaEnum.Adicional, "Adicional"],
        [ContagemCargaHorariaEnum.NaoLetivaBase, "Não Letiva Base"],
        [ContagemCargaHorariaEnum.NaoLetivaEventual, "Não Letiva Eventual"],
        [
            ContagemCargaHorariaEnum.NaoLetivaSubstituicao,
            "Nâo Letiva Substituição",
        ],
        [ContagemCargaHorariaEnum.HoraExtra, "Hora Letiva RE"],
    ]
);

export { ContagemCargaHorariaEnum, ContagemCargaHorariaEnumLabel };
